// services/fetchHistoricPayrolls.js
export async function fetchHistoricPayrolls(getToken, backendUrl) {
    const token = await getToken();

    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setMonth(startDate.getMonth() - 12);

    const safeStartDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        Math.min(startDate.getDate(), 28)
    );

    const requestBody = {
        start_date: safeStartDate.toISOString().split("T")[0],
        end_date: endDate.toISOString().split("T")[0]
    };

    const res = await fetch(`${backendUrl}/payroll_runs`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(requestBody)
    });

    if (!res.ok) {
        throw new Error(`Failed with status ${res.status}`);
    }

    const rawData = await res.json();

    // Convert period_start and period_end to YYYY-MM-DD format
    return rawData.map(run => ({
        ...run,
        period_start: new Date(run.period_start).toISOString().split("T")[0],
        period_end: new Date(run.period_end).toISOString().split("T")[0],
    }));
}
